import { gql } from '@apollo/client';

export const ADD_COST_ORDER = gql`
  mutation AddCostOrder($input: CostOrderInput) {
    addCostOrder(input: $input) {
      result
    }
  }
`;

export const GET_COST_ORDER = gql`
  query GetCostOrder($input: String) {
    costOrderDetail(input: $input) {
      id
      costOrderId
      costOrderDate
    }
  }
`;

export const UPDATE_COST_ORDER = gql`
  mutation UpdateCostOrder($input: CostOrderUpdateDetails) {
    updateCostOrder(input: $input) {
      result
    }
  }
`;

export const ADD_COST_CLAIM = gql`
  mutation AddCostClaim($input: CostClaimInput) {
    addCostClaim(input: $input) {
      result
    }
  }
`;

export const GET_COST_CLAIMS = gql`
  query GetCostClaims($input: String) {
    costClaims(input: $input) {
      data {
        id
        partyId
        partyName
        costClaimDate
        costClaimComment
      }
    }
  }
`;

export const GET_COST_CLAIM = gql`
  query GetCostClaim($input: CostClaimQuery) {
    costClaimDetail(input: $input) {
      id
      costClaimComment
      costClaimDate
      partyId
    }
  }
`;

export const UPDATE_COST_CLAIM = gql`
  mutation UpdateCostClaim($input: CostClaimUpdateDetails) {
    updateCostClaim(input: $input) {
      result
    }
  }
`;

export const DELETE_COST_CLAIM = gql`
  mutation DeleteCostClaim($input: CostClaimQuery) {
    deleteCostClaim(input: $input) {
      result
    }
  }
`;